import { render } from "./LinkPropsCmp.vue?vue&type=template&id=c8cdce40"
import script from "./LinkPropsCmp.vue?vue&type=script&lang=js"
export * from "./LinkPropsCmp.vue?vue&type=script&lang=js"

import "./LinkPropsCmp.vue?vue&type=style&index=0&id=c8cdce40&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__